import {ActionTypes, CCUtils, DataActionTypes, Constants } from './../../cc-imports'

import _ from 'lodash';



const initialState = {
    byId: {},
    byLeague: {},
    byCreatorId:{},
    liveScores:{},

    pages : {},

    reqStatus:'',
    error: '',
    random : 0,
    type : DataActionTypes.GET
};

    const processData = (oldState, newEntries,type, id)=>{
    const byId = _.keyBy(newEntries, 'id');
    var existingEntriesByIds = oldState.byId ? oldState.byId : [];
    existingEntriesByIds =  _.merge({}, existingEntriesByIds, byId);

    var byLeague = CCUtils.groupByGetIds(newEntries, 'league','id');
    byLeague = type==DataActionTypes.PAGINATE?  _.mergeWith({},oldState.byLeague, byLeague, CCUtils.customArrMerger):  _.mergeWith({}, byLeague, oldState.byLeague, CCUtils.customArrMerger);

    var byCreatorId = CCUtils.groupByGetIds(newEntries, 'creator','id');
    byCreatorId = type==DataActionTypes.PAGINATE?  _.mergeWith({},  oldState.byCreatorId, byCreatorId, CCUtils.customArrMerger) : _.mergeWith({}, byCreatorId, oldState.byCreatorId, CCUtils.customArrMerger);

    var pages = oldState.pages;

    if(id){
        if(pages[id]==undefined){
            pages[id]=0;
        }
        if(type==DataActionTypes.PAGINATE || type==DataActionTypes.GET){
            pages[id]=pages[id]+1;
        }
    }

    var liveScores={};
    _.forIn(existingEntriesByIds,(entry, id)=>{
        if(entry.status==Constants.entryStatus.LIVE){
            liveScores[id] = entry.score;
        }
    });

    return {
        byId: existingEntriesByIds,
        byLeague: byLeague,
        byCreatorId:byCreatorId,
        liveScores : liveScores,
        pages : pages
    }
};

const EntryReducers = (state = initialState, action = {}) => {
    switch (action.type) {
        case (ActionTypes.ENTRY_UPDATED):
            return {
                ...state,
                ...processData(state , [action.payload], action.meta.type, action.meta.id)
            }
            break;
        case (ActionTypes.getCCFulfilled(ActionTypes.GET_ENTRIES)):
            return {
                ...state,
                reqStatus: Constants.reqStatus.SUC,
                random:Math.random(),
                error : '',
                type : action.meta.type,
                ...processData(state , action.payload.data.item, action.meta.type, action.meta.id),
            };
            break;
        case (ActionTypes.getFulfilled(ActionTypes.GET_ENTRIES)):
            return {
                ...state,
                reqStatus: action.meta.type==DataActionTypes.PAGINATE ? Constants.reqStatus.COM : Constants.reqStatus.FAI,
                type: action.meta.type
            }
            break;
        case (ActionTypes.getPending(ActionTypes.GET_ENTRIES)):
            return {
                ...state,
                reqStatus:Constants.reqStatus.PEN,
                type: action.meta.type
            }
            break;
        case (ActionTypes.getRejected(ActionTypes.GET_ENTRIES)):
            return {
                ...state,
                reqStatus:Constants.reqStatus.FAI,
                type: action.meta.type
            }
            break;


        case (ActionTypes.getCCFulfilled(ActionTypes.CREATE_ENTRY)):
            let singleEntry = action.payload.data.item;
            singleEntry.new = true;
            return {
                ...state,
                reqStatus:Constants.reqStatus.COM,
                error: '',
                type: action.meta.type,
                random:Math.random(),
                ...processData(state,[singleEntry], action.meta.type, undefined)
            };
            break;
        case (ActionTypes.getFulfilled(ActionTypes.CREATE_ENTRY)):
            return {
                ...state,
                reqStatus:Constants.reqStatus.FAI,
                error: action.payload.data.statusDescription,
                type: action.meta.type
            }
            break;
        case (ActionTypes.getPending(ActionTypes.CREATE_ENTRY)):
            return {
                ...state,
                reqStatus:Constants.reqStatus.PEN,
                type: action.meta.type
            }
            break;
        case (ActionTypes.getRejected(ActionTypes.CREATE_ENTRY)):
            return {
                ...state,
                reqStatus:Constants.reqStatus.FAI,
                type: action.meta.type
            }
            break;
        case ActionTypes.SIGN_OUT_USER:
            var emptryInitialState = initialState;
            //emptryInitialState.entries.entries={};
            return emptryInitialState;
            break;
        case ActionTypes.CLOSE_MODAL:
            return {...state, pages:{}};
        default :
            return state;
    }
};

export default EntryReducers;



// WEBPACK FOOTER //
// ./src/app/data/reducers/EntryReducers.js